import {$,w} from './constants';

// Forward to fondo single URL
$('.fondo_nav_JS').click(function () {
	$(this).toggleClass('active')
})